/*
 * SmartHome-Energy — Maßanfertigungs-Gate (Warenkorb + Checkout)
 * ---------------------------------------------------------------------------
 * Maßanfertigungen (Laufmeter-Zuschnitt nach Kundenmaß) sind gemäß
 * § 18 Abs. 1 Z 3 FAGG vom Widerruf ausgenommen. Sobald so ein Artikel im
 * Warenkorb liegt, blendet dieses Skript
 *   1. den Hinweis samt Pflicht-Checkbox direkt über dem Kasse-Button ein
 *      (Warenkorbseite UND beide Cart-Drawer) und
 *   2. sperrt Kasse-Button, Kasse-Links und Express-Checkout-Buttons, bis
 *      bestätigt wurde.
 *
 * Erkennung: /cart.js → item.properties._massanfertigung (setzt der
 * Laufmeter-Konfigurator) ODER die sichtbare Eigenschaft „Ausführung"
 * mit „Maßanfertigung". Markenneutral, kein Vendor-Bezug.
 *
 * v2 (20.08.2026) — Relaunch-Theme „Homepage Relaunch - AUG 2026":
 * Das Theme bringt einen EIGENEN Warenkorb-Drawer mit
 * (div.shx-cartd[data-shx-cart] > aside.shx-cartd__panel > .shx-cartd__foot)
 * und darin einen reinen Link <a href="/cart/checkout">Zur Kasse</a> statt
 * eines <button name="checkout">. Die v1 kannte nur den alten Enterprise-
 * Drawer und ließ diesen Weg ungesperrt — man kam ohne Bestätigung in den
 * Checkout. Neu deshalb:
 *   - SCOPES/placeGates kennen [data-shx-cart] und .shx-cartd
 *   - LINKS (a[href*="/checkout"]) werden mitgesperrt
 *   - zusätzliche Klick-Sperre in der Capture-Phase, unabhängig vom Markup
 *
 * Warum JavaScript und nicht Liquid:
 * Der Cart-Drawer wird bei jeder Warenkorb-Änderung komplett neu ins DOM
 * geschrieben. Inline-Skripte aus so eingefügtem HTML führt der Browser nicht
 * aus — eine Liquid-Lösung wäre nach dem ersten Nachladen wirkungslos.
 * Dieses Skript wird einmal je Seitenaufruf geladen (snippets/doc-head-core)
 * und beobachtet das DOM.
 *
 * Es werden ausschließlich Elemente wieder freigegeben, die dieses Skript
 * selbst gesperrt hat (Markierung data-she-ma-locked). Fremde disabled-
 * Zustände (leerer Warenkorb, Theme-AGB-Checkbox) bleiben unangetastet.
 */
(function () {
  'use strict';

  if (window.__sheMaGate) return;
  window.__sheMaGate = true;

  var BUTTONS = 'button[name="checkout"],input[name="checkout"]';
  var LINKS = 'a[href*="/checkout"]';
  var BLOCKS =
    '.dynamic-cart-btns,.additional-checkout-buttons,[data-shopify="dynamic-checkout-cart"],' +
    'shopify-accelerated-checkout,shopify-accelerated-checkout-cart,' +
    LINKS;
  var SCOPES =
    'cart-drawer,[data-shx-cart],.shx-cartd,.cart__summary,.cart-drawer__summary,form#cart,.cart,body';

  var TEXT =
    'Dein Warenkorb enthält eine Maßanfertigung. Zuschnitte nach deinem Maß werden eigens ' +
    'für dich gefertigt und sind gemäß § 18 Abs. 1 Z 3 FAGG vom Widerrufs- und Rückgaberecht ' +
    'ausgenommen. Bitte prüfe deine Maße, bevor du bestellst. Gewährleistung und ' +
    'Herstellergarantie bleiben davon unberührt.';
  var CONFIRM =
    'Ich habe verstanden, dass die Maßanfertigung in meinem Warenkorb vom Widerruf ' +
    'ausgenommen ist, und meine Maße geprüft.';

  var CSS =
    '.she-ma{display:flex;align-items:flex-start;gap:10px;margin:14px 0;padding:12px 14px;' +
    'border:1px solid rgba(255,102,0,.32);border-left:4px solid #ff6600;border-radius:12px;' +
    'background:#fff4ec;font-family:inherit;text-align:start}' +
    '.she-ma[hidden]{display:none}' +
    '.she-ma__ic{flex:none;margin-top:1px;color:#ff6600;display:flex}' +
    '.she-ma__body{min-width:0;flex:1 1 auto}' +
    '.she-ma__txt{margin:0;font-size:13.5px;line-height:1.55;color:#2b2f36}' +
    '.she-ma__txt strong{color:#111}' +
    '.she-ma__txt a{color:#ff6600;font-weight:600;text-decoration:underline}' +
    '.she-ma__confirm{display:flex;align-items:flex-start;gap:9px;margin:10px 0 0;' +
    'font-size:13px;line-height:1.5;color:#2b2f36;cursor:pointer}' +
    '.she-ma__confirm input{flex:none;width:18px;height:18px;margin:1px 0 0;accent-color:#ff6600;cursor:pointer}' +
    '.she-ma__lock{margin:8px 0 0;font-size:12.5px;font-weight:600;color:#c0392b}' +
    '.she-ma__lock[hidden]{display:none}' +
    '.she-ma--cart{margin:0 0 14px}' +
    '.she-ma-locked{opacity:.45;pointer-events:none}';

  var ICON =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false">' +
    '<path d="M3 8.5 8.5 3l12.5 12.5L15.5 21z"/><path d="M7 12.5l1.8 1.8"/>' +
    '<path d="M10.5 9l1.8 1.8"/><path d="M14 5.5l1.8 1.8"/></svg>';

  var hasMassanfertigung = false;
  var confirmed = false;

  function ensureCss() {
    if (document.getElementById('she-ma-css')) return;
    var style = document.createElement('style');
    style.id = 'she-ma-css';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  function itemIsMa(item) {
    var p = item && item.properties;
    if (!p) return false;
    if (p._massanfertigung) return true;
    var a = p['Ausführung'];
    return typeof a === 'string' && a.indexOf('Maßanfertigung') !== -1;
  }

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .then(function (cart) {
        if (!cart || !cart.items) return;
        var found = false;
        for (var i = 0; i < cart.items.length; i++) {
          if (itemIsMa(cart.items[i])) {
            found = true;
            break;
          }
        }
        if (found !== hasMassanfertigung) {
          hasMassanfertigung = found;
          if (!found) confirmed = false;
        }
        render();
      })
      .catch(function () {});
  }

  function buildGate() {
    var wrap = document.createElement('div');
    wrap.className = 'she-ma she-ma--cart';
    wrap.setAttribute('data-she-ma-gate', '');

    var ic = document.createElement('span');
    ic.className = 'she-ma__ic';
    ic.setAttribute('aria-hidden', 'true');
    ic.innerHTML = ICON;

    var body = document.createElement('div');
    body.className = 'she-ma__body';

    var txt = document.createElement('p');
    txt.className = 'she-ma__txt';
    var strong = document.createElement('strong');
    strong.textContent = 'Maßanfertigung im Warenkorb. ';
    txt.appendChild(strong);
    txt.appendChild(document.createTextNode(TEXT));

    var label = document.createElement('label');
    label.className = 'she-ma__confirm';
    var box = document.createElement('input');
    box.type = 'checkbox';
    box.setAttribute('data-she-ma-check', '');
    box.checked = confirmed;
    var span = document.createElement('span');
    span.textContent = CONFIRM;
    label.appendChild(box);
    label.appendChild(span);

    var lock = document.createElement('p');
    lock.className = 'she-ma__lock';
    lock.setAttribute('data-she-ma-lockmsg', '');
    lock.hidden = true;
    lock.textContent = 'Bitte bestätige den Hinweis, um zur Kasse zu gehen.';

    body.appendChild(txt);
    body.appendChild(label);
    body.appendChild(lock);
    wrap.appendChild(ic);
    wrap.appendChild(body);
    return wrap;
  }

  function anchorsFor(scope) {
    var host =
      scope.querySelector('.cart-drawer__checkout-buttons') ||
      (scope.querySelector(BUTTONS) && scope.querySelector(BUTTONS).parentNode) ||
      scope.querySelector('.dynamic-cart-btns') ||
      scope.querySelector(LINKS) ||
      scope.querySelector('.shx-cartd__foot') ||
      null;
    return host;
  }

  function placeGates() {
    var scopes = [];
    var drawer = document.querySelector('cart-drawer');
    var shxDrawer = document.querySelector('[data-shx-cart]') || document.querySelector('.shx-cartd');
    var summary = document.querySelector('.cart__summary');
    if (drawer) scopes.push(drawer);
    if (shxDrawer) scopes.push(shxDrawer);
    if (summary) scopes.push(summary);

    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      var existing = scope.querySelector('[data-she-ma-gate]');
      if (!hasMassanfertigung) {
        if (existing) existing.parentNode.removeChild(existing);
        continue;
      }
      if (existing) {
        var b = existing.querySelector('[data-she-ma-check]');
        if (b && b.checked !== confirmed) b.checked = confirmed;
        continue;
      }
      var host = anchorsFor(scope);
      if (!host) continue;
      var gate = buildGate();
      host.parentNode.insertBefore(gate, host);
    }
  }

  function scopeOf(node) {
    return node.closest(SCOPES) || document.body;
  }

  function lock(el) {
    if (el.matches(BUTTONS)) {
      if (el.disabled) return;
      el.disabled = true;
      el.setAttribute('data-she-ma-locked', '1');
    } else {
      if (el.classList.contains('she-ma-locked')) return;
      el.classList.add('she-ma-locked');
      el.setAttribute('data-she-ma-locked', '1');
      el.setAttribute('aria-disabled', 'true');
    }
  }

  function unlock(el) {
    if (!el.hasAttribute('data-she-ma-locked')) return;
    el.removeAttribute('data-she-ma-locked');
    if (el.matches(BUTTONS)) {
      el.disabled = false;
    } else {
      el.classList.remove('she-ma-locked');
      el.removeAttribute('aria-disabled');
    }
  }

  function applyLocks() {
    var locked = document.querySelectorAll('[data-she-ma-locked]');
    for (var i = 0; i < locked.length; i++) unlock(locked[i]);

    if (!hasMassanfertigung || confirmed) return;

    var gates = document.querySelectorAll('[data-she-ma-gate]');
    for (var g = 0; g < gates.length; g++) {
      var scope = scopeOf(gates[g]);
      var targets = scope.querySelectorAll(BUTTONS + ',' + BLOCKS);
      for (var t = 0; t < targets.length; t++) lock(targets[t]);
    }
  }

  function render() {
    ensureCss();
    placeGates();
    applyLocks();
  }

  function showReason(near) {
    var gate =
      (near && scopeOf(near).querySelector('[data-she-ma-gate]')) ||
      document.querySelector('[data-she-ma-gate]');
    if (!gate) return;
    var msg = gate.querySelector('[data-she-ma-lockmsg]');
    if (msg) msg.hidden = false;
    var box = gate.querySelector('[data-she-ma-check]');
    if (box) box.focus();
  }

  document.addEventListener('change', function (evt) {
    var box = evt.target && evt.target.closest ? evt.target.closest('[data-she-ma-check]') : null;
    if (!box) return;
    confirmed = box.checked;
    var gates = document.querySelectorAll('[data-she-ma-gate]');
    for (var i = 0; i < gates.length; i++) {
      var other = gates[i].querySelector('[data-she-ma-check]');
      if (other && other !== box) other.checked = confirmed;
      var msg = gates[i].querySelector('[data-she-ma-lockmsg]');
      if (msg && confirmed) msg.hidden = true;
    }
    applyLocks();
  });

  document.addEventListener(
    'click',
    function (evt) {
      var el = evt.target && evt.target.closest ? evt.target.closest('[data-she-ma-locked]') : null;
      if (!el) return;
      if (el.tagName === 'A') {
        evt.preventDefault();
        evt.stopPropagation();
      }
      showReason(el);
    },
    true
  );

  document.addEventListener(
    'click',
    function (evt) {
      if (!hasMassanfertigung || confirmed) return;
      var a = evt.target && evt.target.closest ? evt.target.closest(LINKS) : null;
      if (!a) return;
      evt.preventDefault();
      evt.stopPropagation();
      showReason(a);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (evt) {
      if (!hasMassanfertigung || confirmed) return;
      var form = evt.target;
      if (!form || !form.matches || !form.matches('form')) return;
      var submitter = evt.submitter;
      var goesToCheckout =
        (submitter && submitter.name === 'checkout') || !!form.querySelector('[data-she-ma-locked]');
      if (!goesToCheckout) return;

      evt.preventDefault();
      showReason(form);
    },
    true
  );

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      render();
    });
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        var own = false;
        for (var a = 0; a < r.addedNodes.length; a++) {
          var n = r.addedNodes[a];
          if (n.nodeType === 1 && (n.hasAttribute('data-she-ma-gate') || n.id === 'she-ma-css')) own = true;
        }
        if (!own) {
          schedule();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  [
    'on:cart:add',
    'on:cart:change',
    'on:cart:error',
    'dispatch:cart-drawer:refresh',
    'dispatch:cart-drawer:open',
    'on:line-item:change'
  ].forEach(function (name) {
    document.addEventListener(name, function () {
      window.setTimeout(readCart, 60);
    });
  });

  window.addEventListener('pageshow', readCart);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', readCart);
  } else {
    readCart();
  }
})();